import { gql } from 'urql';

export const ConfirmCheckDeposit = gql`
  mutation ConfirmCheckDeposit(
    $idempotencyId: IdempotencyToken!
    $input: ConfirmRdcInput!
  ) {
    confirmRdc(idempotencyId: $idempotencyId, input: $input) {
      ... on ConfirmRdcSuccess {
        __typename
        code
        confirmed
        confirmationNumber
      }
      ... on ConfirmRdcError {
        __typename
        code
        title
        message
      }
      ... on ConfirmRdcCancelled {
        __typename
        code
        title
        message
      }
    }
  }
`;

export default ConfirmCheckDeposit;
